import { TemplatePosition } from 'entities/campaign/rulesets/template-position';
import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useSetEmbeddedPosition = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (payload: { id: string; position: TemplatePosition }) => dispatch({ type: 'SET_EMBEDDED_POSITION', payload }),
    [dispatch],
  );
};
